import CloseIcon from '@material-ui/icons/Close';
import { keyBy } from 'lodash';
import React, { useEffect, useState } from 'react';
import {
  Datagrid, FunctionField,
  ListContextProvider,
  Pagination, SelectInput, SimpleForm, TextField, TextInput, Toolbar, useNotify, useQuery, useRefresh
} from 'react-admin';
import Modal from 'react-modal';
import { customDataProvider } from '../data-provider';
import { formatPhoneNumber, getLocations } from '../utils';
import { TeamMembersTabs } from './tabs';
import { useDebouncedCallback } from 'use-debounce';
export const InactiveUsersList = ({ ...props }) => {
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(5);
  const [showModal, setShowModal] = useState(false);
  const [ userDetails, setUserDetails ] = useState();
  

  const [inactiveStaffFilter, setInactiveStaffFilter] = useState({});
  const [workLocations, setWorkLocations] = useState([]);
  const selectedLocation = JSON.parse( localStorage.getItem( 'selectedLocation' ) );
  
  const refresh = useRefresh();
  const notify = useNotify();

  const { data, total } = useQuery({
    type: 'getList',
    resource: 'inactiveUsers',
    payload: {
      filter: {
        is_active: 'false',
        name: inactiveStaffFilter.name,
        location_id: inactiveStaffFilter.location_id
          ? inactiveStaffFilter.location_id
          : selectedLocation,
       },
      pagination: { page, perPage },
    },
  });

    useEffect(() => {
    customDataProvider.getList('userlocations').then(data => {
      setWorkLocations(data.data);
    });
    }, [] );
  
  const PostPagination = props => (
    <Pagination rowsPerPageOptions={[10, 25]} {...props} />
  );

  const activateMember = id => {
    customDataProvider.update('updateTeamUser', { id, is_active: true }).then(
      () => {
        notify('Account Activated!');
        refresh();
      },
      err => {
        notify(
          err.response ? err.response?.data?.message : err.message,
          'error',
        );
        refresh();
      },
    );
  };

  const inActiveConfirmModal = () => {
    const header = 'Activate Account';
    const buttonText = 'Active';
    const bodyContent = 'Activate this user?';
    return (
      <Modal isOpen={showModal}>
        <div className="modal-header">
          <div className="light-text">{header}</div>
          <CloseIcon
            onClick={() => setShowModal(false)}
            className="close-button"
          />
        </div>
        <div className="btn-padding">
          {bodyContent}
          <div className="py-5">
            <b>Name: </b>
            {userDetails?.first_name} {userDetails?.last_name}
          </div>
        </div>
        <div className="details-display btn-padding">
          <div>
            <button
              className="button-blue button-red"
              onClick={() => setShowModal(false)}
            >
              Cancel
            </button>
          </div>
          <div align="right">
            <button
              className="button-blue"
              onClick={() => {
                setShowModal(false);
                activateMember(userDetails?.id);
              }}
            >
              {buttonText}
            </button>
          </div>
        </div>
      </Modal>
    );
  };
  const confirmModal = () => {
    setShowModal(true);
  };

    const handleChange = useDebouncedCallback(e => {
    const { name, value } = e;
    const filters = {
      name: name === 'name' ? value : inactiveStaffFilter.name,
      location_id:
        name === 'location_id' ? value : inactiveStaffFilter.location_id,
    };
    setInactiveStaffFilter({ ...filters });
    }, 300 );
  
    const OtherStaffFilters = () => {
    return (
      <SimpleForm
        className="styled-form2"
        toolbar={<Toolbar style={{ display: 'none' }} />}
        initialValues={{
          name: inactiveStaffFilter.name,
          location_id: inactiveStaffFilter.location_id
            ? inactiveStaffFilter.location_id
            : selectedLocation,
        }}
      >
        <div className="grid-3">
          <TextInput
            source="name"
            label="Name"
            onChange={e => handleChange(e.target)}
          />
          <SelectInput
            source="location_id"
            alwaysOn
            choices={getLocations(workLocations)}
            className="select-no-label"
            onChange={e => handleChange(e.target)}
          />
        </div>
      </SimpleForm>
    );
    };
  
  return (
    <>
      {inActiveConfirmModal()}
      <TeamMembersTabs selectedTab={ 'inactive' } />
      <OtherStaffFilters />
      <ListContextProvider
        value={{
          resource: 'employee',
          basePath: `/employee`,
          data: keyBy(data, 'id'),
          ids: data && data.map(({ id }) => id),
          currentSort: { field: 'id', order: 'ASC' },
          selectedIds: [],
          total,
          page,
          setPage,
          perPage,
          setPerPage,
        }}
        className="main-table"
      >
        <Datagrid>
          <FunctionField
            label="Name"
            render={record =>
              record.last_name
                ? `${record.first_name} ${record.last_name}`
                : `${record.first_name}`
            }
          />
          <TextField source="email" label="Email" />
          <FunctionField
            label="Phone"
            source="phone"
            sortable={false}
            render={record => formatPhoneNumber(record.phone)}
          />
          <TextField source="role" label="Role" />
          <FunctionField
            render={record => {
              return (
                <button
                  className="button-blue"
                  onClick={() => {
                    setUserDetails(record);
                    confirmModal();
                  }}
                >
                  Activate
                </button>
              );
            }}
          />
        </Datagrid>
        <PostPagination
          page={page}
          perPage={perPage}
          setPage={setPage}
          total={total}
        />
      </ListContextProvider>
    </>
  );
};
